import React, { useState, useEffect } from "react"
import "./styles.scss"
import { Container, ChakraProvider, Box } from "@chakra-ui/react"
import { Helmet } from 'react-helmet'
import { primary } from "../constants/colors"
import NavBar from "../components/Layout/NavBar"
import { Element } from "react-scroll"
import Footer from "../components/Layout/Footer"
import Main from "./Main"
import About from "./About"
import Experience  from "./Experience"
import Activities from "./Activities"
import Skills from "./Skills"
import Projects from "./Projects"
import Fonts from "../components/Fonts"
import theme from "../theme"
import favicon from "../images/favicon.ico"


const MainPage = () => {
  const [screenWidth, setScreenWidth] = useState(0)
  const [windowLoaded, setWindowLoaded] = useState(false)

  useEffect(() => {
    if (typeof window !== undefined) {
      setScreenWidth(window.innerWidth)
      setWindowLoaded(true)
    }
  }, [])

  const setNavbar = ()  => {
    if (windowLoaded && screenWidth > 990) {
        return <NavBar />
    } else {
      return <Box w="100%" mb={10} py={12} />
    }
  }

  return (
    <div style={{position: 'relative', overflow: 'hidden'}}>
      <ChakraProvider theme={theme}>
        <Fonts />
        <Container maxW={["container.sm", "container.sm", "container.lg", "container.lg"]} px={[8, 50, 100, 0]} minH="100vh">
          {setNavbar()}
          <Helmet>
            {/* <link rel="preload" as="font" href="../static/fonts/TTCommonsBold.ttf" type="font/ttf" crossOrigin="anonymous" />
            <link rel="preload" as="font" href="../static/fonts/TTCommonsMedium.ttf" type="font/ttf" crossOrigin="anonymous" />
            <link rel="preload" as="font" href="../static/fonts/TTCommonsRegular.ttf" type="font/ttf" crossOrigin="anonymous" /> */}
            <title>Adrienne Rio</title>
            <style>{`body { background-color: ${primary}; }`}</style>
            <link rel="icon" href={favicon} />
          </Helmet>
          <Main />
          <Element name="about">
            <About />
          </Element>
          <Element name="experience">
            <Experience />
          </Element>
          <Element name="activities">
            <Activities />
          </Element>
          <Element name="skills">
            <Skills />
          </Element>
          <Element name="projects">
            <Projects />
          </Element>
          <Footer />
        </Container>
      </ChakraProvider>
    </div>
  )
}

export default MainPage
